if( ! window._bilingualTheme.settings["fix_thumbnail_container_height"] ) {
	$(function() {
		var thumbnails = $('#collection .thumbnail, .thumbnail-small'),
			images = $('.product-thumbnail-image'),
			captionTops = $('#collection .thumbnail .caption-top'),
			titles = $('#collection .thumbnail .caption-top h4');

		window.resizeThumbnailImages = function(){
			var maxHeight = 0,
				minHeight = 0;

			$.each(images, function(i, obj) {
				var obj = $(obj),
					image = obj.find('img').first(),
					imgHeight = image.innerHeight();

				if(minHeight != 0){
					minHeight = (imgHeight < minHeight) ? imgHeight : minHeight;
				}else{
					minHeight = imgHeight;
				}

				maxHeight = (imgHeight > maxHeight) ? imgHeight : maxHeight;
			});

			var diff = maxHeight - minHeight;
			if( diff > 50 ){
				maxHeight = minHeight + (diff / 2);
			}

			images.height(maxHeight);
		}
		window.resizeThumbnails = function(){
			var maxHeight = 0;

			$.each(thumbnails, function(i, obj) {
				var obj = $(obj),
					contents = obj.find(">*"),
					totalHeight = 0;

				$.each(contents, function(i, val) {
					val = $(val);
					totalHeight += val.height();
				});

				maxHeight = (totalHeight > maxHeight) ? totalHeight : maxHeight;
			});

			maxHeight = (maxHeight > 0) ? maxHeight : 180;
			thumbnails.height(maxHeight);
		}
		window.resizeTitles = function() {
			var maxHeight = 0;

			$.each(titles, function(i, obj) {
				var obj = $(obj),
					titleHeight = obj.height();

				maxHeight = (titleHeight > maxHeight) ? titleHeight : maxHeight;
			});

			titles.height(maxHeight);
		}
		window.resizeCaptionTops = function() {
			var maxHeight = 0;

			$.each(captionTops, function(i, obj) {
				var obj = $(obj),
					captionTopHeight = obj.height();

				maxHeight = (captionTopHeight > maxHeight) ? captionTopHeight : maxHeight;
			});

			captionTops.height(maxHeight);
		}

		setTimeout(function(){
			$('#collection').show();
			window.resizeThumbnailImages();
			window.resizeThumbnails();
			window.resizeTitles();
			window.resizeCaptionTops();
		}, 500);

		$(window).on('resize', function(e){
			window.resizeThumbnailImages();
			window.resizeThumbnails();
			window.resizeTitles();
			window.resizeCaptionTops();
		});
	});
}